const hexToRgb = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));
const mix = (rgb, to, t) => rgb.map((c) => Math.round(c + (to - c) * t));
const css = (rgb) => `rgb(${rgb.join(" ")})`;
const STEPS = { 50: [255, 0.92], 100: [255, 0.82], 200: [255, 0.64], 300: [255, 0.44], 400: [255, 0.22], 500: [0, 0], 600: [0, 0.12], 700: [0, 0.26], 800: [0, 0.42] };

export const applyBrandColor = (hex) => {
  const root = document.documentElement;
  if (!hex || !/^#[0-9a-fA-F]{6}$/.test(hex)) {
    Object.keys(STEPS).forEach((k) => root.style.removeProperty(`--on-brand-${k}`));
    return;
  }
  const rgb = hexToRgb(hex);
  Object.entries(STEPS).forEach(([k, [to, t]]) => root.style.setProperty(`--on-brand-${k}`, css(mix(rgb, to, t))));
};
